import {
  BADGE_LABEL_COLORS,
  BADGE_STATUSES,
  BadgeLabel,
  TableColumn
} from '@hevoio/hevo-ui-toolkit';
import { IWorkspace } from '../../../../interfaces/workspace';
import { WorkspaceActionMenu } from './WorkspaceActionMenu';
import {
  WORKSPACE_STATUS_BADGE_COLORS,
  WORKSPACE_STATUS_LABELS
} from '../../../../constants/workspaceStatus';
import styles from './WorkspaceListTable.module.scss';

export const workspaceListColumns = (
  onDeleteClick: (workspace: IWorkspace) => void
): TableColumn<IWorkspace>[] => [
  {
    id: 'workspace_seq',
    field: 'workspace_seq',
    headerName: '#',
    width: 100,
    isFlexible: false,
    renderCell: params => <span className={styles.idBadge}>#{params.row.data.workspace_seq}</span>
  },
  {
    id: 'name',
    field: 'name',
    headerName: 'Workspace Name',
    width: 200,
    isFlexible: true,
    renderCell: params => (
      <div className={styles.nameCell}>
        <span className={styles.namePrimary}>{params.row.data.name}</span>
        <span className={styles.nameSlug}>{params.row.data.workspace_id}</span>
      </div>
    )
  },
  {
    id: 'created_ts',
    field: 'created_ts',
    headerName: 'Created on',
    width: 200,
    isFlexible: false,
    renderCell: params => {
      const date = new Date(params.row.data.created_ts);
      const formatted = date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
      return <span className={styles.dateCell}>{formatted}</span>;
    }
  },
  {
    id: 'status',
    field: 'status',
    headerName: 'Status',
    width: 160,
    isFlexible: false,
    justifyEnd: true,
    renderCell: params => {
      const status = params.row.data.status;
      const label = WORKSPACE_STATUS_LABELS[status] ?? status;
      return (
        <BadgeLabel
          className={styles.badgePadding}
          color={WORKSPACE_STATUS_BADGE_COLORS[status] ?? BADGE_LABEL_COLORS.FADED}
          status={BADGE_STATUSES[0]}
          children={label}
        ></BadgeLabel>
      );
    }
  },
  {
    id: 'actions',
    field: 'actions',
    headerName: null,
    width: 60,
    isFlexible: false,
    justifyEnd: true,
    renderCell: params => (
      <WorkspaceActionMenu workspace={params.row.data} onDeleteClick={onDeleteClick} />
    )
  }
];
